<template>
<div class="mt10 mb10">
    <div class="" style="margin-left: 300px;" v-for="proc in procs" :key="proc.key">
        <div class="">
            <div>{{proc.name}}: {{proc.args.join(' ')}}</div>
            <div v-bind:title="proc.timeAgo + ' ago'" v-bind:value="proc.lastRunDate">
                Last Run: {{proc.lastRunDate}}
            </div>
            <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="activeSwitch" @change="toggleProc(proc)">
                <label class="custom-control-label" for="activeSwitch">{{(proc.isSuspended ? 'Disabled' : 'Active')}}</label>
            </div>
            <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="debugSwitch" @change="toggleDebug(proc)">
                <label class="custom-control-label" for="debugSwitch">Debug</label>
            </div>
            <br />
            <button v-if="proc.isSuspended" type="button" class="btn btn-primary" @click="runOnce(proc)">Run Once</button>
        </div>
        <hr />

    </div>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Process } from '../../../models/Process'

export default defineComponent({
  name: "Process",
  data() {
      return {
        procs: Array<Process>(),
      }
  },
  beforeCreate() {
      this.$store.state.axiosService.GetAdminProcs()
        .then((response : any) => {
            this.procs = response;
            this.procs.forEach(proc => {
                proc.lastRunDate = this.FriendlyDateString(proc.lastRunDate);
                proc.timeAgo = this.ToTimeAgo(proc.lastRunDate, { defaultValue: 'Never' });
            })
        }).catch((response : any) =>{
        })
  },
  methods: {
    suspendedToggleText(proc : any) {
        return proc.isSuspended ? "Suspended" : "Active";
    },

    toggleProc(proc : any) {
        proc.isSuspended = !proc.isSuspended;
    },

    toggleDebug(proc : any) {
        proc.debug = !proc.debug;
    },

    runOnce(proc : any, options : any) {
        options = options || {};
        var procReq = {
            name: proc.name,
            runOnce: true,
            debug: options.debug,
        };
        this.$store.state.axiosService.RunAdminProc(procReq)
        .then((response : any) => {
            this.procs.forEach(proc => {
                if (proc.name === response.name) {
                    proc.lastRunDate = this.FriendlyDateString(response.lastRunDate);
                    proc.timeAgo = this.ToTimeAgo(response.lastRunDate, { defaultValue: 'Never' });
                }
            })
            console.log(response)
        }).catch((response : any) =>{
        })
    },

    FriendlyDateString(dateString : string) : string {
        var date = new Date(dateString);
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    },

    ToTimeAgo(dateString : string, options? : any) : string {
        var date = new Date(dateString);
        options = options || {};

        var seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);
        var interval = Math.floor(seconds / 31536000);

        if (interval > 1) {
            if (interval > 200 && options.defaultValue)
                return options.defaultValue;

            return interval + " years";
        }

        interval = Math.floor(seconds / 2592000);
        if (interval > 1) {
            return interval + " months";
        }

        interval = Math.floor(seconds / 86400);
        if (interval > 1) {
            return interval + " days";
        }

        interval = Math.floor(seconds / 3600);
        if (interval > 1) {
            return interval + " hours";
        }

        interval = Math.floor(seconds / 60);
        if (interval > 1) {
            return interval + " minutes";
        }

        return Math.floor(seconds) + " seconds";
    }
  }
})
</script>